import React from "react";
import styled from "@emotion/styled";
import Accordion from "./ui/Accordion";

export default function FAQs({ faqItems }) {
  // Split items into two columns for desktop view
  const halfLength = Math.ceil(faqItems.length / 2);
  const leftColumnItems = faqItems.slice(0, halfLength);
  const rightColumnItems = faqItems.slice(halfLength);

  return (
    <div>
      <DeviceDefault>
        <Column>
          <Accordion items={leftColumnItems} />
        </Column>
        <Column>
          <Accordion items={rightColumnItems} />
        </Column>
      </DeviceDefault>
      <DeviceMobile>
        <Accordion items={faqItems} />
      </DeviceMobile>
    </div>
  );
}

const DeviceDefault = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 24px;
  padding: 24px;
  width: 1200px;
  margin: 16px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    width: calc(100% - 32px);
    margin: 0px;
  }

  @media (max-width: 768px) {
    display: none;
    margin: 0px;
  }
`;

const DeviceMobile = styled.div`
  display: none;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 24px;
  padding: 24px;
  margin: 16px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    margin: 0px;
    padding: 16px;
  }
`;

const Column = styled.div`
  flex: 1;
  min-width: 0; // Prevents flex items from overflowing
`;
